export const AUTH_SIGNIN = "AUTH_SIGNIN";
export const AUTH_SIGNUP = "AUTH_SIGNUP";
export const AUTH_VERIFY_TOKEN = "AUTH_VERIFY_TOKEN";
export const AUTH_FORGOT_PASSWORD = "AUTH_FORGOT_PASSWORD";
export const AUTH_SET_NEW_PASSWORD = "AUTH_SET_NEW_PASSWORD";

export const TYPE_VIEWER = "VIEWER";
export const TYPE_ACCOUNT = "ACCOUNT";
export const TYPE_TENANCY = "TENANCY";

export const ROOT_DOMAINS = [
  "http://localhost:8080",
  "https://console.espx.cloud",
  "http://localhost:4000",
  "https://switzh.tv",
  "https://preprod-ott.switzh.tv",
];
